import { handleErrorResp, httpClient } from "../../../Service/Service";

export const fetchRefillTransactionsByAgent = async (agentName: string): Promise<any> => {
    try {
        return await httpClient<any>(`refillsale/get`, "POST", { agentName: agentName });
    } catch (err) {
        return handleErrorResp(err) as any;
    }
};